import moment from "moment";
import * as React from "react";
import { toast } from "react-toastify";
import { Modal } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import { getValue } from "@utils/lodash";
import "../configure.scss";
import {
	getSpecificComplianceReports,
	updateReport,
} from "@services/reports.service";
import { ReactMultiEmail, isEmail } from "react-multi-email";
import "react-multi-email/style.css";
import DatePicker from "react-datepicker";
import { runTimeList } from "@_common/month";
interface IConfigurePopupProps {
	isOpen: boolean;
	handleModal: () => void;
	selectedIDs: [];
	handleModalCancel: () => void;
	getDataRefetch: () => void;
	configureID: string;
	setConfigureID: any;
}

const ConfigurePopup: React.FunctionComponent<IConfigurePopupProps> = (
	props: any
) => {
	/* -------------------------------------------------------------------------- */
	/*                               UseState Section                             */
	/* -------------------------------------------------------------------------- */
	const [isLoading, setIsLoading] = React.useState(false);
	const [emails, setEmails] = React.useState<any>([]);
	const [request, setRequest] = React.useState<any>({
		email_recipients: "",
		activity_range: "DAILY",
		once_in_every: "",
		on_day: "",
		on_month: "",
		report_run_time: null,
		report_type: "VENDOR_AUDIT",
		is_scheduled: true,
		scheduled_date: null,
	});

	const [frequency] = React.useState([
		{ label: "One Time", value: "ONE_TIME" },
		{ label: "Recurring", value: "RECURRING" },
	]);

	const [activity_range] = React.useState([
		{ label: "Daily", value: "DAILY" },
		{ label: "Weekly", value: "WEEKLY" },
		{ label: "Monthly", value: "MONTHLY" },
		// { label: "Yearly", value: "YEARLY" },
	]);

	const [days, setDays] = React.useState<[] | any>([]);
	const [daysObject] = React.useState([
		{ label: "Sun", value: "1" },
		{ label: "Mon", value: "2" },
		{ label: "Tue", value: "3" },
		{ label: "Wed", value: "4" },
		{ label: "Thu", value: "5" },
		{ label: "Fri", value: "6" },
		{ label: "Sat", value: "7" },
	]);

	const [months] = React.useState([
		{ label: "1", value: "1" },
		{ label: "2", value: "2" },
		{ label: "3", value: "3" },
		{ label: "4", value: "4" },
		{ label: "5", value: "5" },
		{ label: "6", value: "6" },
		{ label: "7", value: "7" },
		{ label: "8", value: "8" },
		{ label: "9", value: "9" },
		{ label: "10", value: "10" },
		{ label: "11", value: "11" },
		{ label: "12", value: "12" },
	]);

	const [monthString] = React.useState([
		{ label: "Jan", value: "1" },
		{ label: "Feb", value: "2" },
		{ label: "Mar", value: "3" },
		{ label: "Apr", value: "4" },
		{ label: "May", value: "5" },
		{ label: "Jun", value: "6" },
		{ label: "Jul", value: "7" },
		{ label: "Aug", value: "8" },
		{ label: "Sep", value: "9" },
		{ label: "Oct", value: "10" },
		{ label: "Nov", value: "11" },
		{ label: "Dec", value: "12" },
	]);

	/* -------------------------------------------------------------------------- */
	/*                               UseEffect Section                            */
	/* -------------------------------------------------------------------------- */
	React.useEffect(() => {
		let array = [];
		for (let i = 0; i < 30; i++) {
			array.push({
				value: i + 1,
				label: i + 1,
			});
		}
		setDays(array);
	}, [props.permissionAPITriggered]);

	React.useEffect(() => {
		getData(props.configureID);
	}, [props.configureID]);

	/* -------------------------------------------------------------------------- */
	/*                               API Section                                  */
	/* -------------------------------------------------------------------------- */

	const getData = async (id: string) => {
		try {
			let resp = await getSpecificComplianceReports(id);
			if (resp) {
				setRequest({
					...request,
					legal_due_date: getValue(resp, `data.legal_due_date`, "")
						? new Date(getValue(resp, `data.legal_due_date`, ""))
						: null,
					frequency_type: getValue(resp, `data.frequency_type`, ""),
					activity_range: getValue(resp, `data.activity_range`, "")
						? getValue(resp, `data.activity_range`, "")
						: "DAILY",
					once_in_every: getValue(resp, `data.once_in_every`, ""),
					on_day: getValue(resp, `data.on_day`, ""),
					on_month: getValue(resp, `data.on_month`, ""),
					report_run_time: getValue(resp, `data.report_run_time`, ""),
					// ? new Date(
					// 		moment(new Date()).format("YYYY-MM-DD") +
					// 			"T" +
					// 			getValue(resp, `data.report_run_time`, "")
					//   )
					// : null,
					scheduled_date: getValue(resp, `data.scheduled_date`, "")
						? new Date(getValue(resp, `data.scheduled_date`, ""))
						: null,
				});
				setEmails(
					getValue(resp, `data.email_recipients`, "")
						? getValue(resp, `data.email_recipients`, "").split(",")
						: []
				);
			}
		} catch (error) {}
	};

	const handleSubmit = async () => {
		try {
			setIsLoading(true);
			let payload = JSON.parse(JSON.stringify(request));
			let obj: any = {
				email_recipients:
					getValue(emails, `length`, 0) > 0 ? emails.toString() : "",
				activity_range: getValue(payload, `activity_range`, ""),
				once_in_every: parseInt(getValue(payload, `once_in_every`, "")),
				on_day: parseInt(getValue(payload, `on_day`, "")),
				on_month: parseInt(getValue(payload, `on_month`, "")),
				report_type: getValue(payload, `report_type`, ""),
				report_run_time: parseFloat(getValue(payload, `report_run_time`, "")),
				// ? moment(getValue(payload, `report_run_time`, "")).format("hh:mm:ss")
				// : "",
				scheduled_date: getValue(payload, `scheduled_date`, "")
					? moment(getValue(payload, `scheduled_date`, "")).format("YYYY-MM-DD")
					: null,
				is_scheduled: true,
			};
			// Object.keys(obj).forEach((key) => {
			// 	if ((!obj[key] || obj[key] === undefined )&& obj[key] !== 'report_run_time') {
			// 		delete obj[key];
			// 	}
			// });
			let resp = await updateReport(props.configureID, obj);
			if (resp) {
				setIsLoading(false);
				toast.success("Submitted successfully");
				props.handleModalCancel();
				props.getDataRefetch();
				setEmails([]);
				setRequest({
					...request,
					email_recipients: "",
					activity_range: "DAILY",
					once_in_every: "",
					on_day: "",
					on_month: "",
					report_run_time: null,
					report_type: "VENDOR_AUDIT",
				});
				getData(props.configureID);
			} else {
				setIsLoading(false);
			}
		} catch (error) {
			setIsLoading(false);
		}
	};
	/* -------------------------------------------------------------------------- */
	/*                               Onchange section                             */
	/* -------------------------------------------------------------------------- */

	const handleCancel = () => {
		setRequest({
			...request,
			email_recipients: "",
			activity_range: "DAILY",
			once_in_every: "",
			on_day: "",
			on_month: "",
			report_run_time: null,
			report_type: "VENDOR_AUDIT",
		});
		props.setConfigureID("");
		props.handleModal();
	};
	return (
		<Modal
			isOpen={props.isOpen}
			className="add-comments-popup-config"
			centered
		>
			<div className="config-modal-content">
				<div className="configure-wrapper__frequency d-flex align-items-center">
					<img
						src="/images/checkpoint/frequency.svg"
						className="configure-wrapper__frequency-icon img-fluid"
						alt="test"
					/>
					Schedule Report
				</div>
				<div className="d-flex align-items-center gap"></div>
				<div className="configure-wrapper__create-recuring-task form-group mt-3">
					<div className="d-flex align-items-center">
						{activity_range.map((item: object) => {
							return (
								<div
									onClick={() =>
										setRequest({
											...request,
											activity_range: getValue(item, `value`, ""),
										})
									}
									className={`configure-wrapper__create-time ${
										getValue(item, `value`, "") ===
										getValue(request, `activity_range`, "")
											? "active"
											: ""
									}`}
								>
									{getValue(item, `label`, "")}
								</div>
							);
						})}
					</div>

					{getValue(request, "activity_range", "") === "DAILY" && (
						<div className="d-flex align-items-center mb-3">
							<label className="configure-wrapper__create-label">Every</label>
							<div className="d-flex align-items-center">
								<InputField
									inputType="INPUT_REACT_SELECT"
									className="configure-wrapper__form-control form-control m-0"
									value={days.filter(
										(item: any) =>
											item.value == getValue(request, `once_in_every`, "")
									)}
									options={days}
									onChange={(e: object) =>
										setRequest({
											...request,
											once_in_every: getValue(e, `value`, ""),
										})
									}
								/>
								<p className="mx-2">day(s)</p>
							</div>
						</div>
					)}
					{getValue(request, "activity_range", "") === "WEEKLY" && (
						<>
							<div className="d-flex align-items-center mb-3">
								<label className="configure-wrapper__create-label">Every</label>
								<div className="d-flex align-items-center">
									<InputField
										inputType="INPUT_REACT_SELECT"
										options={days}
										value={days.filter(
											(item: any) =>
												item.value == getValue(request, `once_in_every`, "")
										)}
										onChange={(e: object) =>
											setRequest({
												...request,
												once_in_every: getValue(e, `value`, ""),
											})
										}
									/>
									<p className="mx-2">Weeks(s)</p>
								</div>
							</div>

							<div className="d-flex align-items-center form-group">
								<label className="configure-wrapper__create-label">On</label>
								<div className="d-flex align-items-center">
									<div className="configure-wrapper__form-control">
										<InputField
											inputType="INPUT_REACT_SELECT"
											options={daysObject}
											value={daysObject.filter(
												(item: any) =>
													item.value == getValue(request, `on_day`, "")
											)}
											onChange={(e: object) =>
												setRequest({
													...request,
													on_day: getValue(e, `value`, ""),
												})
											}
										/>
									</div>
									<p className="mx-2">Day</p>
								</div>
							</div>
						</>
					)}
					{getValue(request, "activity_range", "") === "MONTHLY" && (
						<>
							<div className="d-flex align-items-center form-group">
								<label className="configure-wrapper__create-label">
									Once In Every
								</label>
								<div className="d-flex align-items-center">
									<InputField
										inputType="INPUT_REACT_SELECT"
										options={months}
										value={months.filter(
											(item: any) =>
												item.value == getValue(request, `once_in_every`, "")
										)}
										onChange={(e: object) =>
											setRequest({
												...request,
												once_in_every: getValue(e, `value`, ""),
											})
										}
									/>

									<p className="mx-2">Months(s)</p>
								</div>
							</div>

							<div className="d-flex align-items-center form-group">
								<label className="configure-wrapper__create-label">On</label>
								<div className="d-flex align-items-center">
									<div className="configure-wrapper__form-control">
										<InputField
											inputType="INPUT_REACT_SELECT"
											options={days}
											value={days.filter(
												(item: any) =>
													item.value == getValue(request, `on_day`, "")
											)}
											onChange={(e: object) =>
												setRequest({
													...request,
													on_day: getValue(e, `value`, ""),
												})
											}
										/>
									</div>
									<p className="mx-2">Day</p>
								</div>
							</div>
						</>
					)}
				</div>
				<div className="d-flex">
					<div className="form-group cursor-pointer grid d-flex">
						<div className="input-grid-item">
							<label className="release-date-wrapper__vendor-label">
								Report Runtime
							</label>
							<InputField
								inputType="INPUT_REACT_SELECT_MODAL"
								options={runTimeList}
								value={runTimeList.filter(
									(item: any) =>
										item.value == getValue(request, `report_run_time`, "")
								)}
								onChange={(e: object) =>
									setRequest({
										...request,
										report_run_time: getValue(e, `value`, ""),
									})
								}
							/>
						</div>
					</div>
					&nbsp;&nbsp;&nbsp;
					<div className="form-group cursor-pointer grid">
						<div className="position-relative input-grid-item">
							<label className="release-date-wrapper__vendor-label">
								Schedule Date
							</label>
							{/* <label onClick={(e) => e.preventDefault()}> */}
							<InputField
								inputType="DATETYPE-DOB-MODAL"
								value={
									getValue(request, `scheduled_date`, "")
										? new Date(getValue(request, `scheduled_date`, ""))
										: null
								}
								placeholderText="Start Date"
								onChange={(date: any) =>
									setRequest({ ...request, scheduled_date: date })
								}
								minDate={new Date()}
							/>
							<img
								src="/images/checkpoint/calender.svg"
								className="img-fluid form-image form-image--calender"
							/>
							{/* </label> */}
						</div>
					</div>
				</div>

				<div className="form-group mb-0">
					<div className="d-flex">
						<label className="release-date-wrapper__vendor-label">
							Email Recipients
						</label>
					</div>
					<ReactMultiEmail
						placeholder="Enter Email Recipients"
						emails={emails}
						onChange={(_emails: string[]) => {
							setEmails(_emails);
						}}
						validateEmail={(email) => {
							return isEmail(email); // return boolean
						}}
						getLabel={(
							email: string,
							index: number,
							removeEmail: (index: number) => void
						) => {
							return (
								<div data-tag key={index}>
									{email}
									<span data-tag-handle onClick={() => removeEmail(index)}>
										×
									</span>
								</div>
							);
						}}
					/>
				</div>
				<div className="d-flex justify-content-end">
					<button
						className="ascent-button ascent-button--header-buttons ascent-button--primary"
						onClick={handleCancel}
					>
						Cancel
					</button>
					{isLoading ? (
						<button className="ascent-button ascent-button--header-buttons ascent-button--secondary">
							Please wait...
						</button>
					) : (
						// !props.configureID && (
						<button
							className="ascent-button ascent-button--header-buttons ascent-button--secondary"
							onClick={handleSubmit}
							// disabled={props.configureID ? true : false}
						>
							Submit
						</button>
						// )
					)}
				</div>
			</div>
		</Modal>
	);
};

export default ConfigurePopup;
